/**
 * Flattens a hierarchical menu tree into a single-level array.
 *
 * @param menus - The hierarchical menu tree to flatten.
 * @returns A flat array of all menu nodes.
 */
export function flattenMenus(menus) {
    const result = [];
    const walk = (items) => {
        for (const item of items) {
            const { children, ...rest } = item;
            result.push(item); // Keep the whole item including children or just rest? 
            // Usually, for filtering we might want the rest, but keeping children allows nested filtering if needed later.
            // Reference used rest, but let's see. Original code used { children, ...rest } and pushed rest.
            if (children?.length) {
                walk(children);
            }
        }
    };
    walk(menus);
    return result;
}
